<template>
  <div>
    <base-modal :show="showModal" @close="handleClose" @save="saveEdit">
      <template v-slot:header> Note </template>
      <template v-slot:main>
        <div>
          <textarea
            class="w-full h-24 border-2 p-2"
            v-model="newData.note"
          ></textarea>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import BaseModal from "@/components/ui/elements/BaseModal";
export default {
  name: "AddNote",
  components: { BaseModal },
  props: ["showModal", "newData"],
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    saveEdit() {
      this.$notify({
        title: "Order",
        message: "Saving...",
        type: "success",
      });
      this.$store.dispatch("order/add_note", this.newData).then((resp) => {
        if (!resp.success) return;

        this.$notify({
          title: "Order",
          message: "This note has been saved",
          type: "success",
        });
        this.$emit("saved");
      });
    },
  },
  computed: {},
  mounted() {},
};
</script>

<style scoped></style>
